import { lazy } from 'react';

/** Открывает форму версии приложения */
export const AppVersionFormPageAsync = lazy(() => import('./AppVersionForm/AppVersionFormPage'));
